const setAttestations = (state, payload) => {
  state.attestations = payload;
};
export default {
  setAttestations,
};
